module.exports = __webpack_public_path__ + "img/11.1fe020c2.jpg";